import EpiComponent from '@episerver/spa-core/EpiComponent';
import React, {ReactNode, ReactNodeArray} from 'react';
import AbroadTroubleshootingWizardBlockData from "../../../Models/Content/AbroadTroubleshootingWizardBlockData";
import AbroadTroubleshootingWizard
  from "app/Components/Block/AbroadTroubleshootingWizardBlock/AbroadTroubleshootingWizard";


export default class AbroadDataTroubleshootingWizardBlock extends EpiComponent<AbroadTroubleshootingWizardBlockData> {
  constructor(props) {
    super(props);
  }

  public render(): ReactNode | ReactNodeArray | null {
    return <AbroadTroubleshootingWizard context={this.getContext()} contentData={this.props.data} />;
  }
}
